<template>
	<div>
		<v-chip outlined :color="color" style="border:none" class="pa-0"
			><span class="font-weight-normal">
				{{ $t("resultStatus." + status) }}
			</span>
		</v-chip>
		<span v-if="checkStatus()"> {{ Math.ceil(value) }}%</span>
		<div class="progress-bar" v-if="checkStatus()">
			<v-progress-linear
				v-model="value"
				:active="show"
				:indeterminate="query"
				:query="true"
			>
			</v-progress-linear>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		status: {
			type: String,
			default: "",
		},
		principal: {
			type: Boolean,
			default: true,
		},
		projectId: {
			type: Number,
			default: 0,
		},
		isProgress: {
			type: Boolean,
			default: false,
		},
		progressValue: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			value: 5,
			query: false,
			show: true,
		};
	},
	computed: {
		color: {
			get() {
				if (this.principal)
					if (this.status === "Finished") return "#6d7278";
					else if (
						this.status === "Approved" ||
						this.status === "DownloadCompleted" ||
						this.status === "shared"
					)
						return "#62be00";
					else if (
						this.status === "PreApproved" ||
						this.status === "DownloadCompleted"
					)
						return "#00C3B2";
					else if (
						this.status === "Denied" ||
						this.status === "DownloadIncomplete" ||
						this.status === "unshared"
					)
						return "#e02020";
					else if (
						this.status === "Failed" ||
						this.status === "FailedNoRecordings"
					)
						return "#fa8e04";
					else if (this.status === "Paused" || this.status === "Expired")
						return "#F9A825";
					else return "#5f98ed";
				else {
					if (this.status === "Finished") return "#6d7278";
					else if (this.status === "Failed") return "#fa8e04";
					else if (this.status === "Paused" || this.status === "Expired")
						return "#F9A825";
					else return "#5f98ed";
				}
			},
		},
		progressDownload: {
			get() {
				return this.$store.getters.getProgressDownload;
			},
			set(value) {
				return this.$store.commit("setProgressDownload", value);
			},
		},
	},
	methods: {
		checkStatus() {
			let ids = [];
			let progress = [];
			ids.push(this.$store.getters.getProgressDownload.id);
			progress.push(this.$store.getters.getProgressDownload.prog);
			if (this.status === "Extracting" && this.isProgress) {
				if (
					this.$store.getters.getProgressDownload.id ===
					this.projectId.toString()
				) {
					this.value = this.$store.getters.getProgressDownload.prog;
				}
				return true;
			} else {
				return false;
			}
		},
	},
	mounted() {
		this.value = this.progressValue;
	},
};
</script>
<style>
.progress-bar {
	min-height: 4px !important;
}
</style>
